import {
  RESET_CONDITION_FILTER,
  RESET_ITEM_FILTER,
  RESET_MOVEMENT_FILTER,
  RESET_TREATMENT_FILTER,
  SET_CONDITION_AS_FILTERED,
  SET_ITEM_AS_FILTERED,
  SET_ITEM_SEARCH_AS_ADVANCED,
  SET_MOVEMENT_AS_FILTERED,
  SET_TREATMENT_AS_FILTERED,
  UPDATE_CONDITION_FILTER,
  UPDATE_ITEM_FILTER,
  UPDATE_MOVEMENT_FILTER,
  UPDATE_TREATMENT_FILTER,
  RESET_POI_FILTER,
  SET_POI_AS_FILTERED,
  UPDATE_POI_FILTER,
  RESET_NEWS_FILTER,
  SET_NEWS_AS_FILTERED,
  SET_NEWS_SEARCH_AS_ADVANCED,
  UPDATE_NEWS_FILTER,
  RESET_BEACON_FILTER,
  SET_BEACON_AS_FILTERED,
  SET_BEACON_SEARCH_AS_ADVANCED,
  UPDATE_BEACON_FILTER,
} from '../reducers/types';

export const updateItemFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_ITEM_FILTER,
      payload: filterParams,
    });
    if (
      filterParams.description ||
      filterParams.label ||
      filterParams.objectTitle ||
      filterParams.method ||
      filterParams.showcaseNumber ||
      filterParams.locationName
    ) {
      dispatch({
        type: SET_ITEM_SEARCH_AS_ADVANCED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_ITEM_SEARCH_AS_ADVANCED,
        payload: false,
      });
    }
    if (
      filterParams.classification ||
      filterParams.category ||
      filterParams.subcategory ||
      filterParams.country
    ) {
      dispatch({
        type: SET_ITEM_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_ITEM_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetItemFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_ITEM_FILTER,
    });
  };
};

export const updateConditionFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_CONDITION_FILTER,
      payload: filterParams,
    });
    if (filterParams.conditionCategory) {
      dispatch({
        type: SET_CONDITION_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_CONDITION_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetConditionFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_CONDITION_FILTER,
    });
  };
};

export const updateTreatmentFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_TREATMENT_FILTER,
      payload: filterParams,
    });
    if (filterParams.treatmentCategory) {
      dispatch({
        type: SET_TREATMENT_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_TREATMENT_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetTreatmentFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_TREATMENT_FILTER,
    });
  };
};

export const updateMovementFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_MOVEMENT_FILTER,
      payload: filterParams,
    });
    if (
      filterParams.reasonId ||
      filterParams.movementDateStart ||
      filterParams.movementDateEnd ||
      filterParams.returnDateStart ||
      filterParams.returnDateEnd
    ) {
      dispatch({
        type: SET_MOVEMENT_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_MOVEMENT_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetMovementFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_MOVEMENT_FILTER,
    });
  };
};

export const updatePoiFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_POI_FILTER,
      payload: filterParams,
    });
    if (filterParams.groupId || filterParams.itemId) {
      dispatch({
        type: SET_POI_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_POI_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetPoiFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_POI_FILTER,
    });
  };
};

export const updateBeaconFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_BEACON_FILTER,
      payload: filterParams,
    });
    if (
      filterParams.description ||
      filterParams.label ||
      filterParams.objectTitle ||
      filterParams.method ||
      filterParams.showcaseNumber ||
      filterParams.locationName
    ) {
      dispatch({
        type: SET_BEACON_SEARCH_AS_ADVANCED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_BEACON_SEARCH_AS_ADVANCED,
        payload: false,
      });
    }
    if (
      filterParams.classification ||
      filterParams.category ||
      filterParams.subcategory ||
      filterParams.country
    ) {
      dispatch({
        type: SET_BEACON_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_BEACON_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetBeaconFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_BEACON_FILTER,
    });
  };
};

export const updateNewsFilters = filterParams => {
  return async dispatch => {
    dispatch({
      type: UPDATE_NEWS_FILTER,
      payload: filterParams,
    });
    if (
      filterParams.description ||
      filterParams.label ||
      filterParams.objectTitle ||
      filterParams.method ||
      filterParams.showcaseNumber ||
      filterParams.locationName
    ) {
      dispatch({
        type: SET_NEWS_SEARCH_AS_ADVANCED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_NEWS_SEARCH_AS_ADVANCED,
        payload: false,
      });
    }
    if (
      filterParams.classification ||
      filterParams.category ||
      filterParams.subcategory ||
      filterParams.country
    ) {
      dispatch({
        type: SET_NEWS_AS_FILTERED,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_NEWS_AS_FILTERED,
        payload: false,
      });
    }
  };
};

export const resetNewsFilters = () => {
  return dispatch => {
    dispatch({
      type: RESET_NEWS_FILTER,
    });
  };
};
